import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import List from './List'
import { Container } from './styles'

function EventsListSection() {
  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Container px={LANDING_CONTENT_PX} py={[56, 56, 56, 56, 56, 100]}>
          <SubsectionTitle
            centered
            inverse
            subtitle="It’s networking done the smart way."
            title="Upcoming Events"
          />

          <List />
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default EventsListSection
